/*global _ */
import RaceCartItemMixin from '../../../../../components/_mixins/race-cart-item'
import {formatDate, parseDateTime} from '../../../../../lib/dates'
import {fv} from '../../../../../lib/utils'

export default {
  name: 'race-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [RaceCartItemMixin],
  computed: {
    itemProduct() {
      return this.itemAttributes.product || {}
    },
    itemProductMeta() {
      return _.get(this.itemProduct, 'custom', _.get(this.itemProduct, 'meta.custom', {}))
    },
    heatsAlias() {
      return _.startCase(_.get(this.itemProductMeta, 'alias_heats', 'heats'))
    },
    racesAlias() {
      return _.startCase(_.get(this.itemProductMeta, 'alias_races', 'races'))
    },
    racerDetails() {
      return this.itemForm.racerDetails || []
    },
    totalParticipants() {
      return this.itemForm.numberOfAdults
    },
    heatQuantity(){
      return _.values(this.itemForm.selectedSlots || {}).length
    },
    raceQuantity(){
      return this.itemOptions.count || 0
    },
    slottedTimes() {
      return _.reduce(this.cartedSlots, (items, slot) => {
        const {time, racers} = slot
        items.push({time, racers})
        return items
      }, [])
    },
    arriveByTime() {
      const slots = _.values(_.mapValues(_.cloneDeep(this.cartedSlots || []), v => {
        const date = parseDateTime(v.datetime)
        if (date) {
          const parsedDate = parseDateTime(date)
          if (parsedDate.isValid) {
            v.day = parsedDate.weekdayLong.toLowerCase()
            v.parsedDate = parsedDate
          }
        }
        return v
      }))
      const product = this.item.attributes.product || {}
      const arriveThresholds = _.mapValues(
        _.mapKeys(
          _.get(product, 'meta.arrival_threshold', []),
          item => (((item || {}).day || '') + '').toLowerCase()
        ),
        'minutes'
      )

      const slot = _.minBy(slots, 'timeAsNumber')
      const day = slot.day
      const date = slot.parsedDate
      const dateKey = formatDate(date, 'yyyy-MM-dd')
      const offset = fv(
        arriveThresholds[dateKey],
        arriveThresholds[day],
        arriveThresholds['all'],
        0
      )
      if (offset) {
        const offsetDate = date.minus({minutes: offset})
        const time = formatDate(offsetDate, 'h:mm a')
        return time
      }
      return null
    }
  },
  methods: {
    getRacerNameAlias(defaultValue) {
      return _.startCase(_.get(this.itemProductMeta, 'alias_racer', '')) || defaultValue
    },
    getRaceUnitFormatted(quantity) {
      const race = quantity > 1 ? _.get(this.itemProductMeta, 'alias_races', 'races') :
        _.get(this.itemProductMeta, 'alias_race', 'race')
      return `${quantity} ${_.startCase(race)}`
    }
  }
}
